<template>
  <span class="x-label" :style="{ backgroundColor: bgColor }">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type LabelType =
  | 'receipt' | 'kitchen' | 'order' | 'label' | 'nonDiscountable' | 'nonStackable' | 'openEditor'
  | 'table' | 'orderType' | 'discount' | 'customer' | 'warning' | 'info'
  | 'percent' | 'amount';

const TYPE_TO_VAR: Record<string, string> = {
  receipt: '--color-label-receipt',
  kitchen: '--color-label-kitchen',
  order: '--color-label-order',
  label: '--color-label-label-printer',
  nonDiscountable: '--color-label-non-discountable',
  nonStackable: '--color-label-non-stackable',
  openEditor: '--color-label-open-editor',
  table: '--color-label-table',
  orderType: '--color-label-order-type',
  discount: '--color-label-discount',
  customer: '--color-label-customer',
  warning: '--color-label-warning',
  info: '--color-label-info',
  percent: '--color-label-percent',
  amount: '--color-label-amount',
};

const props = defineProps<{ type?: LabelType }>();

const bgColor = computed(() => {
  const varName = props.type ? TYPE_TO_VAR[props.type] || '--color-label-receipt' : '--color-label-receipt';
  return `var(${varName})`;
});
</script>

<style lang="scss">
.x-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 13px;
  padding: 0 4px;
  font-size: var(--fs-11);
  line-height: 14px;
  color: white;
  border-radius: var(--radius-9999);
  white-space: nowrap;
}
</style>
